import request from '@/api/config.js'

// Получение списка всех услуг
export function getAllServices() {
  return request({
    url: `service`,
    method: 'get',
  })
}

/**
 * Получить детали услуги по ID (цена, время, описание)
 * @param {number} id - ID услуги
 * @returns {Promise} Детали услуги
 */
export function getServiceById(id) {
  return request({
    url: `service/${id}/service_details`,
    method: 'get',
  })
}

/**
 * Получить услуги филиала, доступные для конкретного типа кузова
 * Возвращает только услуги, которые предоставляются постами филиала, поддерживающими указанный тип кузова
 * @param {number} departmentId - ID филиала
 * @param {number} carTypeId - ID типа кузова
 * @returns {Promise} Список услуг, доступных для данного типа кузова в данном филиале
 */
export function getDepartmentServicesByCarType(departmentId, carTypeId) {
  return request({
    url: `service/department/${departmentId}/car_type/${carTypeId}/available_services`,
    method: 'get',
  })
}

// Получение списка всех услуг по id организации.
// В Network: services-list
export function getOrgServices(id, params = {}) {
  return request({
    url: `service/org/${id}/services-list`,
    method: 'get',
    params,
  })
}

/**
 * Функция createService отправляет запрос POST в конечную точку service/create с предоставленными
 * данными.
 * @param data - Параметр data — это объект, который содержит данные, которые будут отправлены в теле
 * запроса. Он может включать в себя любую необходимую информацию для создания сервиса.
 * @returns результат вызова функции request.
 */
export function createService(data) {
  return request({
    url: `service/create`,
    method: 'post',
    data,
  })
}

/**
 * Функция updateService отправляет запрос PUT для обновления службы предоставленными данными.
 * @param data - Параметр data — это объект, который содержит обновленную информацию о сервисе. Он
 * передается как полезная нагрузка в теле запроса при выполнении запроса PUT для обновления службы.
 * @returns результат вызова функции request.
 */
export function updateService(data) {
  return request({
    url: `service/`,
    method: 'put',
    data,
  })
}

/**
 * Функция deleteService отправляет на сервер запрос DELETE для удаления службы с указанным
 * идентификатором.
 * @param id - Параметр `id` — это уникальный идентификатор сервиса, который необходимо удалить.
 * @returns Функция deleteService возвращает запрос на удаление службы с указанным идентификатором.
 */
export function deleteService(id) {
  return request({
    url: `service/${id}`,
    method: 'delete',
  })
}

// Обновление порядка категорий и услуг для организации
export function reorderOrgServices(orgId, payload) {
  return request({
    url: `service/org/${orgId}/reorder`,
    method: 'post',
    data: payload,
  })
}
